import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Redirect } from "react-router";

import { getPromoSlides } from "../../../../services/promoSlider/actions";
import { getSingleLanguageData } from "../../../../services/languages/actions";
import { getUserNotifications } from "../../../../services/alert/actions";
import {
  resetInfo,
  resetItems,
  getRestaurantItems,
  getHomeProducts,
  getPriceSortedProducts,
} from "../../../../services/items/actions";
import {
  getDeliveryRestaurants,
} from "../../../../services/restaurant/actions";

import Footer from "../../Footer";
import CategoryGrid from "./Categories/CategoryGrid";
import ItemsSection from "./ItemsSection";
import FilterToggleButtons from "../../../Shared/FilterToggleButtons";
import { getImageUrl } from '../../../../helpers/imageUrl';
import { setAppMode, initializeAppMode } from "../../../../services/settings/actions";
import { AppMode } from "../../../../constants";

class Home extends Component {
  static contextTypes = {
    router: () => null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedMode: 0,
      prevScrollPos: window.pageYOffset,
      visible: true,
      isSearchFixed: false,
      activeFilters: ['distance', 'Top Picks'], // Distance and Top Picks are active by default
      selectedSortFilter: 'distance', // Default selection for sorting group
      selectedContentFilter: 'Top Picks', // Default selection for content type group
      isScrollSpyActive: false, // Flag to prevent scroll conflicts
      filterScrollPosition: 0, // Store horizontal scroll position
      currentSortBy: 'distance', // Track current sort method
      currentSortOrder: 'asc' // Track current sort order
    };
    this.filterContainerRef = React.createRef(); // Ref for filter container
  }

  handleToggle = (mode) => {
    // console.log('Previous mode:', this.state.selectedMode);
    // console.log('Toggling mode to:', mode);
    
    if(mode === 'Quick Commerce') {
      this.props.setAppMode(AppMode.SPRINT);
      // console.log('🔄 Switched to SPRINT mode');
    } else {
      this.props.setAppMode(AppMode.RELAY);
      // Refetch home products with new app mode
      if (localStorage.getItem("userSetAddress") !== null) {
        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        this.props.getHomeProducts(userSetAddress.lat, userSetAddress.lng, userSetAddress.state || "Karnataka", AppMode.RELAY);
        // console.log('🔄 Refetching home products for RELAY mode');
      }
      // console.log('🔄 Switched to RELAY mode');
    }
  };

  // Handle scroll events to show/hide toggle and update active section
  handleScroll = () => {
    const { prevScrollPos } = this.state;
    const currentScrollPos = window.pageYOffset;
    const visible = prevScrollPos > currentScrollPos || currentScrollPos < 10;
    
    // Check if search bar should be fixed
    const searchBar = document.querySelector('.sticky-search-bar');
    const isSearchFixed = searchBar && searchBar.offsetTop !== undefined && currentScrollPos > searchBar.offsetTop;
    
    // Scroll-spy: Determine which section is currently visible
    this.updateActiveSection(currentScrollPos);
    
    this.setState({
      prevScrollPos: currentScrollPos,
      visible,
      isSearchFixed
    });
  };

  // Fetch price sorted data using service
  fetchPriceSortedData = async (sortOrder) => {
    try {
      if (localStorage.getItem("userSetAddress") !== null) {
        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        const lat = userSetAddress.lat;
        const lng = userSetAddress.lng;
        const state = userSetAddress.state || "Karnataka";
        
              // console.log(`🔄 Fetching price sorted data: ${sortOrder}`);
              // console.log('📍 Using coordinates:', { lat, lng, state });
        
        // Check Redux store BEFORE API call
        // console.log('🔍 BEFORE API - Redux priceSortedProducts:', this.props.priceSortedProducts);
        
        // Use the service action instead of direct fetch
        const result = await this.props.getPriceSortedProducts(lat, lng, state, sortOrder);
        
        // console.log('🔍 Service call result:', result);
        
        // Check Redux store AFTER API call
        // console.log('🔍 AFTER API - Redux priceSortedProducts:', this.props.priceSortedProducts);
        
        if (result && result.success && result.tagged_items) {
          // console.log('✅ Price sorted data received with tagged_items:', result.tagged_items);
          // console.log('✅ Sort order:', result.sort_order);
          // console.log('✅ Tagged items breakdown:');
          // console.log('  - Top Picks:', result.tagged_items.is_top_picks && result.tagged_items.is_top_picks.length, 'items');
          // console.log('  - New:', result.tagged_items.is_new && result.tagged_items.is_new.length, 'items');
          // console.log('  - Popular:', result.tagged_items.is_popular && result.tagged_items.is_popular.length, 'items');
          
          // Update local state to track current sort method
          this.setState({
            currentSortBy: 'price',
            currentSortOrder: sortOrder
          });
          
          // console.log('🎯 Updated local state - currentSortBy: price, currentSortOrder:', sortOrder);
          
          // Force a re-render after Redux store is updated with multiple checks
          setTimeout(() => {
            // console.log('🔄 First check - Redux priceSortedProducts:', this.props.priceSortedProducts);
            this.forceUpdate();
          }, 50);
          
          setTimeout(() => {
            // console.log('🔄 Second check - Redux priceSortedProducts:', this.props.priceSortedProducts);
            this.forceUpdate();
          }, 200);
          
          setTimeout(() => {
            // console.log('🔄 Final check - Redux priceSortedProducts:', this.props.priceSortedProducts);
            this.forceUpdate();
          }, 500);
        } else {
          // console.error('❌ Error fetching price sorted data:', result);
        }
      }
    } catch (error) {
      // console.error('❌ Service call failed:', error);
    }
  };

  // Add method to clear price sorted data and re-fetch homeProducts
  clearPriceSortedData = async () => {
    // console.log('🗑️ Clearing price sorted data and re-fetching homeProducts');
    
    // Clear the Redux store for price sorted data
    this.props.getPriceSortedProducts(null, null, null, null);
    
    // Clear local state
    this.setState({
      currentSortBy: 'distance',
      currentSortOrder: 'asc'
    });
    
    // console.log('🎯 Cleared local state - currentSortBy: distance, currentSortOrder: asc');
    
    // Re-fetch homeProducts API for fresh distance-based data
    try {
      if (localStorage.getItem("userSetAddress") !== null) {
        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        const lat = userSetAddress.lat;
        const lng = userSetAddress.lng;
        const state = userSetAddress.state || "Karnataka";
        const currentAppMode = this.props.appMode || 2; // Default to RELAY for Phase2
        
        // console.log('🔄 Re-fetching homeProducts API for distance-based sorting');
        // console.log('📍 Using coordinates:', { lat, lng, state, appMode: currentAppMode });
        
        // Call homeProducts API to get fresh distance-sorted data
        const result = await this.props.getHomeProducts(lat, lng, state, currentAppMode);
        
        // console.log('✅ HomeProducts API re-fetch completed');
        // console.log('🎯 Fresh distance-based data loaded');
        
        // Force re-render to ensure UI updates
        setTimeout(() => {
          this.forceUpdate();
        }, 100);
      }
    } catch (error) {
      // console.error('❌ Error re-fetching homeProducts:', error);
    }
  };

  // Update active section based on scroll position
  updateActiveSection = (scrollPos) => {
    const topPicksSection = document.getElementById('top-picks-section');
    const newSection = document.getElementById('new-arrivals-section');
    const popularSection = document.getElementById('most-popular-section');
    
    // Early return if essential elements are not available
    if (!topPicksSection || !newSection || !popularSection) return;
    
    const sections = [
      { element: topPicksSection, filter: 'Top Picks' },
      { element: newSection, filter: 'New' },
      { element: popularSection, filter: 'Most Popular' }
    ];
    
    // Find which section is currently most visible
    let activeSection = 'Top Picks'; // Default
    const viewportHeight = window.innerHeight;
    const threshold = viewportHeight * 0.3; // 30% of viewport height
    
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      // Additional null check for section element before calling getBoundingClientRect
      if (!section.element) continue;
      const rect = section.element.getBoundingClientRect();
      
      // Check if section is in viewport with some threshold
      if (rect.top <= threshold && rect.bottom > threshold) {
        activeSection = section.filter;
        break;
      }
    }
    
    // Only update if the active section has changed
    if (activeSection !== this.state.selectedContentFilter) {
      // console.log('🔄 Scroll-spy: Active section changed to:', activeSection);
      
      // Store current scroll position before update
      const filterContainer = document.querySelector('.filter-toggle-container');
      const currentScrollLeft = filterContainer ? filterContainer.scrollLeft : 0;
      
      this.setState({
        selectedContentFilter: activeSection,
        activeFilters: [this.state.selectedSortFilter, activeSection],
        isScrollSpyActive: true,
        filterScrollPosition: currentScrollLeft
      });
      
      // Reset scroll-spy flag after brief moment
      setTimeout(() => {
        this.setState({ isScrollSpyActive: false });
      }, 50);
    }
  };

  async componentDidMount() {
    this.props.resetItems();
    this.props.resetInfo();
    const { appMode } = this.props;
    // console.log('Phase2 Home - Initial mode:', appMode);
    this.setState({ selectedMode: appMode });

    // Load restaurants data for items display
    if (localStorage.getItem("userSetAddress") !== null) {
      const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
      await this.props.getDeliveryRestaurants(userSetAddress.lat, userSetAddress.lng);
      
      // Fetch home products with location-based filtering based on current app mode
      // This API call automatically applies distance-based filtering using user's coordinates
      // That's why the "Distance" filter toggle is selected by default
      const currentAppMode = this.props.appMode || AppMode.RELAY; // Default to RELAY for Phase2
      await this.props.getHomeProducts(userSetAddress.lat, userSetAddress.lng, userSetAddress.state || "Karnataka", currentAppMode);
      // console.log('🎯 Home products fetched with distance-based filtering applied for app mode:', currentAppMode);
    }

    // Add scroll event listener
    window.addEventListener('scroll', this.handleScroll);

    //if currentLocation doesnt exists in localstorage then redirect the user to firstscreen
    //else make API calls
    if (localStorage.getItem("userSetAddress") !== null) {
      if (localStorage.getItem("showPromoSlider") === "true") {
        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        if (this.props.user && this.props.user.data) {
          this.props.getPromoSlides(
            userSetAddress.lat,
            userSetAddress.lng,
            this.props.user.data.auth_token,
            this.props.user.data.id
          );
        }
      }

      if (this.props.user.success) {
        this._notificationSubscription = this.props.getUserNotifications(
          this.props.user.data.id, 
          this.props.user.data.auth_token
        );
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Load restaurant items when restaurants are available
    if (this.props.restaurants !== prevProps.restaurants && this.props.restaurants.length > 0) {
      // Use the first available restaurant to load items
      const firstRestaurant = this.props.restaurants[0];
      if (firstRestaurant && firstRestaurant.slug) {
        this.props.getRestaurantItems(firstRestaurant.slug);
      }
    }

    // Restore scroll position after scroll-spy updates
    if (prevState.selectedContentFilter !== this.state.selectedContentFilter && this.state.filterScrollPosition > 0) {
      setTimeout(() => {
        const filterContainer = document.querySelector('.filter-toggle-container');
        if (filterContainer) {
          filterContainer.scrollLeft = this.state.filterScrollPosition;
          // console.log('📍 Restored scroll position to:', this.state.filterScrollPosition);
        }
      }, 100);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.languages !== nextProps.languages) {
      if (localStorage.getItem("userPreferedLanguage")) {
        this.props.getSingleLanguageData(
          localStorage.getItem("userPreferedLanguage")
        );
      } else {
        if (Array.isArray(nextProps.languages) && nextProps.languages.length) {
          const id = nextProps.languages.filter(
            (lang) => lang.is_default === 1
          )[0].id;
          this.props.getSingleLanguageData(id);
        }
      }
    }
  }

  componentWillUnmount() {
    // Remove scroll event listener
    window.removeEventListener('scroll', this.handleScroll);
    
    // Cancel any pending notifications subscription
    if (this._notificationSubscription) {
      this._notificationSubscription.cancel && this._notificationSubscription.cancel();
    }
  }

  render() {
    // console.log('🔄 RENDER CYCLE - Checking price sorting data');
    
    if (window.innerWidth > 768) {
      return <Redirect to="/" />;
    }

    if (localStorage.getItem("userSetAddress") === null) {
      return <Redirect to="/" />;
    }

    const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
    if (
      Object.keys(userSetAddress).length === 0 &&
      userSetAddress.constructor === Object
    ) {
      return <Redirect to="/" />;
    }

    const { user, promo_slides, restaurant_items, appMode, homeProducts, priceSortedProducts } = this.props;
    const {  visible, prevScrollPos, isSearchFixed, selectedMode, currentSortBy, currentSortOrder } = this.state;
    
    // Use properly transformed price-sorted data if available, otherwise use original homeProducts
    let activeProducts = homeProducts;

    // console.log('🔍 DEBUG: Render data check');
    // console.log('  - homeProducts:', homeProducts);
    // console.log('  - priceSortedProducts:', priceSortedProducts);
    // console.log('  - currentSortBy (local state):', currentSortBy);
    // console.log('  - currentSortOrder (local state):', currentSortOrder);
    // console.log('  - selectedSortFilter (local state):', this.state.selectedSortFilter);

    // ENHANCED: Check both Redux store AND local state for better reliability
    const isPriceSortActive = (
      (currentSortBy === 'price') || 
      (this.state.selectedSortFilter === 'price-high-to-low') || 
      (this.state.selectedSortFilter === 'price-low-to-high')
    );
    
    // console.log('🎯 Is price sort active?', isPriceSortActive);

    if (isPriceSortActive && priceSortedProducts && priceSortedProducts.tagged_items) {
      // console.log('🔄 Using PRICE SORTING API data with tagged_items structure');
      // console.log('  - API: /api/v2/home-products?sort_by=price');
      // console.log('  - Sort order:', priceSortedProducts.sort_order);
      // console.log('  - Tagged items structure received from API:');
      // console.log('    - Top Picks:', priceSortedProducts.tagged_items.is_top_picks && priceSortedProducts.tagged_items.is_top_picks.length, 'items');
      // console.log('    - New:', priceSortedProducts.tagged_items.is_new && priceSortedProducts.tagged_items.is_new.length, 'items');
      // console.log('    - Popular:', priceSortedProducts.tagged_items.is_popular && priceSortedProducts.tagged_items.is_popular.length, 'items');
      
      // Use the tagged_items directly from the API response
      activeProducts = {
        ...homeProducts,
        tagged_items: priceSortedProducts.tagged_items
      };
      
      // console.log('✅ Active products set to PRICE SORTING API tagged_items');
      // console.log('  - Each section now shows items sorted by price within that tag');
    } else {
    //   console.log('🎯 Using HOME PRODUCTS API data (distance-sorted)');
    //   console.log('  - API: /api/v2/home-products (distance-based)');
      if (!isPriceSortActive) {
        // console.log('  - Reason: Price sort is not active');
      } else if (!priceSortedProducts) {
        // console.log('  - Reason: priceSortedProducts is null/undefined');
      } else if (!priceSortedProducts.tagged_items) {
        // console.log('  - Reason: priceSortedProducts.tagged_items is missing');
      }
    }

    // console.log('🎯 Final activeProducts passed to ItemsSection:', activeProducts);
    // console.log('🎯 activeProducts.tagged_items structure:');
    if (activeProducts && activeProducts.tagged_items) {
      // console.log('  - Top Picks items:', activeProducts.tagged_items.is_top_picks ? activeProducts.tagged_items.is_top_picks.length : 0);
      // console.log('  - New items:', activeProducts.tagged_items.is_new ? activeProducts.tagged_items.is_new.length : 0);
      // console.log('  - Popular items:', activeProducts.tagged_items.is_popular ? activeProducts.tagged_items.is_popular.length : 0);
      // console.log('  - First Top Pick item:', activeProducts.tagged_items.is_top_picks ? activeProducts.tagged_items.is_top_picks[0] : null);
    }

    // console.log('Current mode:', appMode);
    return (
      <React.Fragment>
        <style>
          {`
            @media (max-width: 375px) {
              .home-deliver-to {
                font-size: 12px !important;
              }
              .home-deliver-to span strong {
                font-size: 12px !important;
              }
            }
            
            @media (max-height: 700px) {
              .storehead-container {
                min-height: 240px !important;
                padding-bottom: 60px !important;
              }
              .toggle-container {
                bottom: 10px !important;
              }
              .deliver-container {
                bottom: 8px !important;
              }
            }
            
            @media (max-width: 320px) {
              .toggle-container button {
                font-size: 14px !important;
                padding: 8px 0 !important;
              }
              .storehead-container {
                min-height: 240px !important;
              }
            }

            .toggle-container {
              transition: transform 0.3s ease, opacity 0.3s ease;
            }
            
            .toggle-hidden {
              transform: translateY(100px);
              opacity: 0;
            }
            
            .toggle-sticky {
              position: fixed;
              bottom: 15px;
              left: 0;
              width: 100%;
              z-index: 1000;
              transform: translateY(0);
              transition: transform 0.3s ease, opacity 0.3s ease;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            
            .toggle-sticky.toggle-hidden {
              transform: translateY(100px);
            }
            
            .toggle-sticky-inner {
              background: rgba(255, 255, 255, 0.95);
              border-radius: 30px;
              display: flex;
              padding: 4px;
              width: 90%;
              max-width: 362px;
              position: relative;
              overflow: hidden;
              box-shadow: 0 2px 15px rgba(0,0,0,0.15);
            }
            
            .toggle-slider {
              position: absolute;
              width: 50%;
              height: 83%;
              background: #FFA500;
              border-radius: 25px;
              top: 8.5%;
              transition: left 0.3s ease;
              z-index: 1;
            }
            
            .toggle-button {
              border: none;
              outline: none;
              background: transparent;
              border-radius: 30px;
              padding: 11px 0;
              fontWeight: 600;
              fontSize: 17.5px;
              cursor: pointer;
              transition: all 0.3s ease;
              width: 50%;
              zIndex: 10;
              position: relative;
              letterSpacing: 0.4px;
            }

           
           
            
            .category-grid {
              display: grid;
              grid-template-columns: repeat(4, 1fr);
              grid-template-rows: repeat(2, 1fr);
              gap: 10px;
              padding: 0 15px;
              margin-bottom: 20px;
            }
            
            .category-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              text-decoration: none;
              color: #333;
            }
            
            .category-item img {
              width: 60px;
              height: 60px;
              border-radius: 30px;
              object-fit: cover;
              margin-bottom: 5px;
            }
            
            .category-item span {
              font-size: 12px;
              text-align: center;
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .height-100-percent {
              overflow: visible !important;
              position: relative;
            }
            
            body, html {
              overflow-x: visible;
            }
            
            .section-title {
              font-size: 18px;
              font-weight: 600;
              
            }
            
            /* Remove all spacing between ItemsSection components */
            .height-100-percent > .phase2-items-section {
              margin: 0 !important;
              padding: 0 !important;
            }
            
            /* Remove spacing from direct children in main container */
            
            
            /* Ultra-aggressive spacing removal */
            .phase2-items-section + .phase2-items-section {
              margin-top: -1px !important;
            }
            
            /* Remove any React component default spacing */
            [class*="phase2-items-section"] {
              margin: 0 !important;
              padding: 0 !important;
              border: none !important;
            }
            
            /* Force compact layout for main content area */
            
            
            /* Remove spacing from React component wrappers */
            .height-100-percent > div {
              margin: 0 !important;
              padding: 0 !important;
            }

            .bg-white {
              background: #fff;
              position: relative;
              z-index: 1;
            }

            

            /* Ensure proper stacking context */
            .phase2-items-section {
              position: relative;
              z-index: 1;
            }

            /* Sticky Filter Toggle Buttons */
            .sticky-filter-container {
              position: sticky;
              top: 60px; /* Position below sticky search bar */
              z-index: 998; /* Lower than search bar but above content */
              background: #fff;
              
              margin-bottom: 10px;
              padding: 5px 0;
            }
            
           
          `}
        </style>
        
        {/* Fixed search bar that shows when scrolling past the original */}
        {/* {isSearchFixed && (
          <div className="fixed-search-bar">
            {localStorage.getItem("mockSearchOnHomepage") === "true" && (
              <Link
                to="/phase2/explore"
                className="anchor-link"
                style={{ width: "100%", display: "block" }}
              >
                <div className="mock-search-block px-15 pb-0" style={{ marginBottom: "-10px" }}>
                  <div
                    className="d-flex justify-content-between"
                    style={{ 
                      padding: "12px 15px",
                      background: "#f5f5f5",
                      borderRadius: "10px",
                      margin: "4px",
                    }}
                  >
                    <div>
                      <span style={{ color: "#777" }}>
                        {localStorage.getItem("mockSearchPlaceholder") || "Search..."}
                      </span>
                    </div>
                    <div>
                      <i className="si si-magnifier" style={{ color: "#555" }} />
                    </div>
                  </div>
                </div>
              </Link>
            )}
          </div>
        )} */}

        <div className="height-100-percent bg-white mb-50">
          {/* Storehead Container with Banner API Integration */}
          {localStorage.getItem("ecommerceHeader") ? (
            <div style={{ position: "relative", marginBottom: "10px" }}>
              <div style={{ position: "relative" }}>
                <div style={{ 
                  position: "relative", 
                  height: "250px",
                  width: "100%",
                  minHeight: "250px",
                  paddingBottom: "60px",
                  overflow: "hidden",
                  backgroundImage: `url(${getImageUrl(`/assets/img/logos/${localStorage.getItem("ecommerceHeader")}`)})`,
                  backgroundSize: "100% 100%",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  borderBottomLeftRadius: "15px",
                  borderBottomRightRadius: "15px",
                }} className="storehead-container">
                  {/* Semi-transparent overlay */}
                  <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.4) 100%)",
                    pointerEvents: "none"
                  }} />
                  
                  {/* Deliver To section - moved to top left corner */}
                  {user && user.data && user.data.default_address ? (
                    <div style={{ 
                      position: "absolute",
                      top: "10px", 
                      left: "15px",
                      zIndex: 2,
                      padding: "0px 0px",
                      borderRadius: "8px",
                    }} className="deliver-container">
                      <Link to="/my-addresses" className="anchor-link">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div>
                            <p style={{ 
                              color: "#fff", 
                              textShadow: "1px 1px 2px rgba(0,0,0,0.7)",
                              margin: 0,
                              fontSize: "15px",
                              lineHeight: 1.4,
                              fontWeight: 500
                            }}>
                              <i className="si si-location-pin" style={{ marginRight: "4px" }}></i>
                              <span style={{ fontWeight: "bold" }}>Deliver to:</span>{" "}
                              {user.data.default_address.tag !== null ? (
                                <span style={{ 
                                  fontWeight: 700,
                                  textTransform: "capitalize"
                                }}>
                                  {user.data.default_address.tag}
                                </span>
                              ) : (
                                <span style={{ fontWeight: 700 }}>Home</span>
                              )}
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null}
                  
                  {/* Toggle View Options */}
                  <div style={{ 
                    position: "absolute",
                    bottom: "10px",
                    left: 0,
                    width: "100%",
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    zIndex: 2,
                    opacity: this.state.prevScrollPos < 50 ? 1 : 0,
                    pointerEvents: this.state.prevScrollPos < 50 ? 'auto' : 'none',
                    transition: 'opacity 0.3s ease'
                  }} className="toggle-container">
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.9)',
                      borderRadius: '30px',
                      display: 'flex',
                      padding: '4px',
                      width: '90%',
                      maxWidth: '362px',
                      position: 'relative',
                      overflow: 'hidden'
                    }}>
                      <div 
                        style={{
                          position: 'absolute',
                          width: '50%',
                          height: '83%',
                          background: '#FFA500',
                          borderRadius: '25px',
                          top: '8.5%',
                          left: selectedMode === 1 ? '2.5%' : '47.5%',
                          transition: 'left 0.3s ease',
                          zIndex: 1,
                        }}
                      />
                      
                      <button
                        onClick={() => this.handleToggle('Quick Commerce')}
                        style={{
                          border: 'none',
                          outline: 'none',
                          background: 'transparent',
                          color: selectedMode === 1 ? '#fff' : '#333',
                          borderRadius: '30px',
                          padding: '11px 0',
                          fontWeight: 600,
                          fontSize: '17.5px',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          width: '50%',
                          zIndex: 10,
                          position: 'relative',
                          letterSpacing: '0.4px'
                        }}
                      >
                        Sprint
                      </button>
                      
                      <button
                        onClick={() => this.handleToggle('ECommerce')}
                        style={{
                          border: 'none',
                          outline: 'none',
                          background: 'transparent',
                          color: selectedMode === 2 ? '#fff' : '#333',
                          borderRadius: '30px',
                          padding: '11px 0',
                          fontWeight: 600,
                          fontSize: '17.5px',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          width: '50%',
                          zIndex: 10,
                          position: 'relative',
                          letterSpacing: '0.4px'
                        }}
                      >
                        Relay
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            // Fallback banner when ecommerceHeader is not available
            <div style={{ position: "relative", marginBottom: "10px" }}>
              <div style={{ position: "relative" }}>
                <div style={{ 
                  position: "relative", 
                  height: "auto",
                  minHeight: "250px",
                  paddingBottom: "60px",
                  overflow: "hidden",
                  backgroundImage: `url(/assets/img/relay-logo.jpg)`,
                  backgroundSize: "cover",
                  backgroundPosition: "center center",
                  borderBottomLeftRadius: "15px",
                  borderBottomRightRadius: "15px",
                }} className="storehead-container">
                  {/* Semi-transparent overlay for better text readability */}
                  <div style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%)",
                  }} />
                  
                  {/* Deliver To section - moved to top left corner */}
                  {user && user.data && user.data.default_address ? (
                    <div style={{ 
                      position: "absolute",
                      top: "0px", 
                      left: "3px",
                      zIndex: 2
                    }} className="deliver-container">
                      <Link to="/my-addresses" className="anchor-link">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div>
                            <p style={{ 
                              color: "#fff", 
                              textShadow: "1px 1px 2px rgba(0,0,0,0.7)",
                              margin: 0,
                              fontSize: "15px",
                              lineHeight: 1.4,
                              fontWeight: 500
                            }}>
                              <i className="si si-location-pin" style={{ marginRight: "4px" }}></i>
                              <span style={{ fontWeight: "bold" }}>Deliver to:</span>{" "}
                              {user.data.default_address.tag !== null ? (
                                <span style={{ 
                                  fontWeight: 700,
                                  textTransform: "capitalize"
                                }}>
                                  {user.data.default_address.tag}
                                </span>
                              ) : (
                                <span style={{ fontWeight: 700 }}>Home</span>
                              )}
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null}
                  
                  {/* Toggle View Options - at bottom of storehead image */}
                  <div style={{ 
                    position: "absolute",
                    bottom: "10px",
                    left: 0,
                    width: "100%",
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    zIndex: 2,
                    opacity: this.state.prevScrollPos < 50 ? 1 : 0,
                    pointerEvents: this.state.prevScrollPos < 50 ? 'auto' : 'none',
                    transition: 'opacity 0.3s ease'
                  }} className="toggle-container">
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.9)',
                      borderRadius: '30px',
                      display: 'flex',
                      padding: '4px',
                      width: '90%',
                      maxWidth: '362px',
                      position: 'relative',
                      overflow: 'hidden'
                    }}>
                      {/* Active Background Indicator */}
                      <div 
                        style={{
                          position: 'absolute',
                          width: '50%',
                          height: '83%',
                          background: '#FFA500',
                          borderRadius: '25px',
                          top: '8.5%',
                          left: selectedMode === 1 ? '2.5%' : '47.5%',
                          transition: 'left 0.3s ease',
                          zIndex: 1,
                        }}
                      />
                      
                      {/* Quick Commerce Button */}
                      <button
                        onClick={() => this.handleToggle('Quick Commerce')}
                        style={{
                          border: 'none',
                          outline: 'none',
                          background: 'transparent',
                          color: selectedMode === 1 ? '#fff' : '#333',
                          borderRadius: '30px',
                          padding: '11px 0',
                          fontWeight: 600,
                          fontSize: '17.5px',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          width: '50%',
                          zIndex: 10,
                          position: 'relative',
                          letterSpacing: '0.4px'
                        }}
                      >
                        Sprint
                      </button>
                      
                      {/* ECommerce Button */}
                      <button
                        onClick={() => this.handleToggle('ECommerce')}
                        style={{
                          border: 'none',
                          outline: 'none',
                          background: 'transparent',
                          color: selectedMode === 2 ? '#fff' : '#333',
                          borderRadius: '30px',
                          padding: '11px 0',
                          fontWeight: 600,
                          fontSize: '17.5px',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          width: '50%',
                          zIndex: 10,
                          position: 'relative',
                          letterSpacing: '0.4px'
                        }}
                      >
                        Relay
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Category Carousel - All categories in horizontal scroll */}
          <CategoryGrid />

          {/* Search functionality with ItemList component */}
          <ItemsSection tag="search" showSearchOnly={true} restaurant_items={restaurant_items} />

          {/* Filter Toggle Buttons - Sticky */}
          <div className="sticky-filter-container">
          <FilterToggleButtons
                            key={`filter-${this.state.selectedContentFilter}-${this.state.selectedSortFilter}`} // Re-render when selection changes
            options={[
                
              { label: 'Distance', value: 'distance', },
              { label: 'Price - High to Low', value: 'price-high-to-low' },
              { label: 'Price - Low to High', value: 'price-low-to-high' },
              
              // { label: 'Rating', value: 'rating' },
              { label: 'Top Picks', value: 'Top Picks' },
              { label: 'New', value: 'New' },
              { label: 'Most Popular', value: 'Most Popular' },
            ]}
            onSelectionChange={(selected) => {
                // console.log('🎯 User clicked filters:', selected);
                // console.log('🔍 Current active filters:', this.state.activeFilters);
                
                // Define filter groups
                const sortFilters = ['distance', 'price-high-to-low', 'price-low-to-high'];
                const contentFilters = ['Top Picks', 'New', 'Most Popular'];
                
                // Find which filter was just clicked (not previously active)
                const previouslyActive = this.state.activeFilters;
                const newlyClicked = selected.find(filter => !previouslyActive.includes(filter));
                
                // console.log('🆕 Newly clicked filter:', newlyClicked);
                
                let newSortFilter = this.state.selectedSortFilter;
                let newContentFilter = this.state.selectedContentFilter;
                
                if (newlyClicked) {
                  if (sortFilters.includes(newlyClicked)) {
                    // User clicked a sort filter - replace current sort filter
                    newSortFilter = newlyClicked;
                    // console.log('📊 Sort filter changed to:', newlyClicked);
                  } else if (contentFilters.includes(newlyClicked)) {
                    // User clicked a content filter - replace current content filter
                    newContentFilter = newlyClicked;
                    // console.log('📋 Content filter changed to:', newlyClicked);
                  }
                }
                
                // Always ensure exactly one filter from each group is active
                const newActiveFilters = [newSortFilter, newContentFilter];
                
                // console.log('✅ Setting new active filters:', newActiveFilters);
                // console.log('📊 New sort filter:', newSortFilter);
                // console.log('📋 New content filter:', newContentFilter);
                
                this.setState({ 
                  activeFilters: newActiveFilters,
                  selectedSortFilter: newSortFilter,
                  selectedContentFilter: newContentFilter
                });
              
                // Handle filter changes here
                if (newSortFilter === 'distance') {
                  // console.log('🎯 Distance filter selected - clearing price data and fetching homeProducts API');
                  this.clearPriceSortedData(); // This will now also re-fetch homeProducts API
                } else if (newSortFilter === 'price-high-to-low') {
                  // console.log('💰 Price High to Low filter selected - fetching sortByPrice API');
                  this.fetchPriceSortedData('desc'); // Fetch highest price first from sortByPrice API
                } else if (newSortFilter === 'price-low-to-high') {
                  // console.log('💰 Price Low to High filter selected - fetching sortByPrice API');
                  this.fetchPriceSortedData('asc'); // Fetch lowest price first from sortByPrice API
                }
                
                // Only scroll to section if this is a manual click (not scroll-spy update)
                if (!this.state.isScrollSpyActive && newlyClicked && contentFilters.includes(newlyClicked)) {
                  if (newContentFilter === 'Top Picks') {
                    // console.log('⭐ Top Picks filter selected - scrolling to section');
                    // Scroll to Top Picks section
                    setTimeout(() => {
                      const topPicksSection = document.getElementById('top-picks-section');
                      if (topPicksSection) {
                        topPicksSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }
                    }, 100);
                  } else if (newContentFilter === 'New') {
                    // console.log('🆕 New filter selected - scrolling to section');
                    // Scroll to New Arrivals section
                    setTimeout(() => {
                      const newSection = document.getElementById('new-arrivals-section');
                      if (newSection) {
                        newSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }
                    }, 100);
                  } else if (newContentFilter === 'Most Popular') {
                    // console.log('🔥 Most Popular filter selected - scrolling to section');
                    // Scroll to Most Popular section
                    setTimeout(() => {
                      const popularSection = document.getElementById('most-popular-section');
                      if (popularSection) {
                        popularSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }
                    }, 100);
                  }
                } else if (this.state.isScrollSpyActive) {
                  // console.log('📍 Scroll-spy update - not scrolling to avoid conflicts');
                }
            }}
            multiSelect={true}
              defaultSelected={this.state.activeFilters} // Use current state as default
            containerStyle={{
              borderBottom: '1px solid #f0f0f0',
            }}
          />
          </div>

          {/* Top Picks Section */}
          <div id="top-picks-section">
            <ItemsSection 
              tag="top_picks" 
              homeProducts={activeProducts}
              currentSortFilter={this.state.selectedSortFilter}
              currentSortOrder={this.state.currentSortOrder}
            />
          </div>

          {/* New Arrivals Section */}
          <div id="new-arrivals-section">
            <ItemsSection 
              tag="new" 
              homeProducts={activeProducts}
              currentSortFilter={this.state.selectedSortFilter}
              currentSortOrder={this.state.currentSortOrder}
            />
          </div>

          {/* Most Popular Section */}
          <div id="most-popular-section">
            <ItemsSection 
              tag="popular" 
              homeProducts={activeProducts}
              currentSortFilter={this.state.selectedSortFilter}
              currentSortOrder={this.state.currentSortOrder}
            />
          </div>

          {/* Sticky Toggle View for scrolling */}
          {/* {prevScrollPos > 50 && (
            <div className={`toggle-sticky ${!visible ? 'toggle-hidden' : ''}`}>
              <div className="toggle-sticky-inner">
                <div 
                  className="toggle-slider"
                  style={{
                    left: selectedMode === 'Quick Commerce' ? '2.5%' : '47.5%'
                  }}
                />
                <button
                  className="toggle-button"
                  onClick={() => this.handleToggle('Quick Commerce')}
                  style={{
                    color: selectedMode === 'Quick Commerce' ? '#fff' : '#333'
                  }}
                >
                  Sprint
                </button>
                <button
                  className="toggle-button"
                  onClick={() => this.handleToggle('ECommerce')}
                  style={{
                    color: selectedMode === 'ECommerce' ? '#fff' : '#333'
                  }}
                >
                  Relay
                </button>
              </div>
            </div>
          )} */}
        </div>

        <Footer active_nearme={true} active_alerts={false} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  promo_slides: state.promo_slides.promo_slides,
  user: state.user.user,
  locations: state.locations.locations,
  languages: state.languages.languages,
  restaurant_items: state.items.restaurant_items,
  restaurants: state.restaurants.restaurants,
  appMode: state.settings.appMode,
  homeProducts: state.items.homeProducts,
  priceSortedProducts: state.items.priceSortedProducts,
});

export default connect(
  mapStateToProps,
  {
    getPromoSlides,
    getUserNotifications,
    resetInfo,
    resetItems,
    getSingleLanguageData,
    getDeliveryRestaurants,
    getRestaurantItems,
    setAppMode,
    initializeAppMode,
    getHomeProducts,
    getPriceSortedProducts,
  }
)(Home); 